module.exports = __webpack_public_path__ + "static/media/8.a86e030c.png";